import { SvgIcon, SvgIconProps } from '@components/shared/SvgIcon'

export function CalendarLightIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={'none'}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Line_200"
        d="M3.0918 9.4025H20.9157"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_201"
        d="M16.4429 13.3088H16.4522"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_202"
        d="M12.0054 13.3088H12.0147"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_203"
        d="M7.55818 13.3088H7.56744"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_204"
        d="M16.4429 17.1955H16.4522"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_205"
        d="M12.0054 17.1955H12.0147"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_206"
        d="M7.55818 17.1955H7.56744"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_207"
        d="M16.0433 2V5.29078"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Line_208"
        d="M7.96515 2V5.29078"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Path"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2383 3.57812H7.77096C4.83427 3.57812 3 5.21406 3 8.22115V17.2708C3 20.3252 4.83427 21.9989 7.77096 21.9989H16.229C19.175 21.9989 21 20.3535 21 17.3464V8.22115C21.0092 5.21406 19.1842 3.57812 16.2383 3.57812Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}
